import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { twMerge } from 'tailwind-merge'
import { DetailsTableDataGroup } from '../models'

export interface DataGroupIconListColsProps {
  isFirstGroup?: boolean
}

export function DataGroupIconListCols({
  values,
  isFirstGroup,
  label,
  labelClassName,
  id,
}: DataGroupIconListColsProps & DetailsTableDataGroup) {
  return (
    <div data-testid="dataGroupIconListCols" className={`-mb-2 grid grid-cols-2 ${!isFirstGroup ? 'pt-6' : ''}`}>
      {label ? <div className={twMerge('col-span-2 pb-[10px]', labelClassName)}>{label}</div> : ''}
      {values?.map((item, i) => (
        <div
          key={`${id}-${item.label}`}
          className={twMerge('col-span-2 inline-block pr-5 pb-2 font-bold md:col-span-1', i % 2 === 1 ? 'md:pl-6' : '')}
        >
          {item.icon ? (
            <FontAwesomeIcon
              data-testid="icon"
              className="text-shades-400 -ml-[6px] w-8 pr-2 text-lg"
              icon={item.icon}
            />
          ) : null}
          {item.label}
        </div>
      ))}
    </div>
  )
}
